export default {
    root: ({ props, context, parent, instance }) => ({
        class: [
            'avatar-root',
            // Size variants
            {
                'avatar-xs': props.size === 'xs',
                'avatar-sm': props.size === 'sm',
                'avatar-md': props.size === 'md' || !props.size, // default to md
                'avatar-lg': props.size === 'lg',
                'avatar-xl': props.size === 'xl',
                'avatar-2xl': props.size === '2xl',
            },
        ],
    }),
};